// extracted by mini-css-extract-plugin
export default {"container":"Slider-module__container__NXnY1","slider":"Slider-module__slider__iZRCx","label":"Slider-module__label__M+T6u"};